import { render, staticRenderFns } from "./SiteFavoriteButton.vue?vue&type=template&id=3110bf78"
import script from "./SiteFavoriteButton.vue?vue&type=script&lang=js"
export * from "./SiteFavoriteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports